import {
  Button,
  ListItemIcon,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

import { MdMenuOpen, MdOutlineMenu } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assests/images/Logo.png";
import SearchBox from "../SearchBox";
import { Logout, LockReset } from "@mui/icons-material";
import React, { useContext, useState } from "react";
import { MyContext } from "../../App";
import { editFeilds } from "../../utils/api";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openPasswordDialog, setOpenPasswordDialog] = useState(false);

  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const openMyAcc = Boolean(anchorEl);

  const history = useNavigate();
  const context = useContext(MyContext);

  // ================= MENU =================
  const handleOpenMyAccDrop = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMyAccDrop = () => {
    setAnchorEl(null);
  };

  // ================= LOGOUT =================
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("loginTime");

    context.setAlertBox({
      open: true,
      error: false,
      msg: "User logout Successfully!",
    });

    setTimeout(() => {
      history("/Login");
    }, 1500);
  };

  // ================= PASSWORD =================
  const handlePasswordInput = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value,
    });
  };

  const openChangePassword = () => {
    setAnchorEl(null);
    setOpenPasswordDialog(true);
  };

  // const changePassword = async () => {

  //     const { currentPassword, newPassword, confirmPassword } = passwordData

  //     if (!currentPassword || !newPassword || !confirmPassword) {
  //         context.setAlertBox({
  //             open: true,
  //             error: true,
  //             msg: "Please fill all fields"
  //         })
  //         return
  //     }

  //     if (newPassword !== confirmPassword) {
  //         context.setAlertBox({
  //             open: true,
  //             error: true,
  //             msg: "Passwords do not match"
  //         })
  //         return
  //     }

  //     const res = await editFeilds("/api/user/change-password", passwordData)

  //     if (!res.error) {
  //         context.setAlertBox({
  //             open: true,
  //             error: false,
  //             msg: "Password updated successfully"
  //         })

  //         setOpenPasswordDialog(false)

  //         setPasswordData({
  //             currentPassword: "",
  //             newPassword: "",
  //             confirmPassword: ""
  //         })
  //     } else {
  //         context.setAlertBox({
  //             open: true,
  //             error: true,
  //             msg: res.msg
  //         })
  //     }
  // }

  const changePassword = async () => {
    const { currentPassword, newPassword, confirmPassword } = passwordData;

    if (!currentPassword || !newPassword || !confirmPassword) {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Please fill all fields",
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "New Passwords and Confirm Password do not match",
      });
      return;
    }

    // 🔥 FIX HERE
    const res = await editFeilds("/api/user/change-password", {
      oldPassword: currentPassword,
      newPassword,
    });

    if (!res.error) {
      context.setAlertBox({
        open: true,
        error: false,
        msg: "Password updated successfully",
      });

      setOpenPasswordDialog(false);

      setPasswordData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } else {
      context.setAlertBox({
        open: true,
        error: true,
        msg: res.msg,
      });
    }
  };

  return (
    <>
      <header className="d-flex align-items-center">
        <div className="container-fluid w-100">
          <div className="row d-flex align-items-center w-100">
            {/* Logo */}
            <div className="col-sm-2 part1">
              <Link to={"/"} className="d-flex align-items-center logo">
                <img src={logo} alt="" />
                <span className="ml-2">ANGIRA</span>
              </Link>
            </div>

            {context.windowWidth > 992 && (
              <div className="col-sm-6 d-flex align-items-center part2 res-hide">
                <Button
                  className="rounded-circle mr-3"
                  onClick={() =>
                    context.setIsToggleSidebar(!context.isToggleSidebar)
                  }
                >
                  {context.isToggleSidebar === false ? (
                    <MdMenuOpen />
                  ) : (
                    <MdOutlineMenu />
                  )}
                </Button>
                <SearchBox />
              </div>
            )}

            {/* RIGHT SIDE */}
            <div className="col-sm-4 d-flex align-items-center justify-content-end part3">
              {context.isLogin !== true ? (
                <Link to={"/login"}>
                  <Button className="btn-blue btn-lg btn-round">Sign In</Button>
                </Link>
              ) : (
                <div className="myAccWrapper">
                  <Button
                    className="myAcc d-flex align-items-center"
                    onClick={handleOpenMyAccDrop}
                  >
                    <div className="userImg">
                      <span className="rounded-circle">
                        {context.user?.name?.charAt(0)}
                      </span>
                    </div>

                    <div className="userInfo res-hide">
                      <h4>{context.user?.name}</h4>
                      <p className="mb-0">{context.user?.email}</p>
                    </div>
                  </Button>

                  {/* ================= MENU ================= */}
                  <Menu
                    anchorEl={anchorEl}
                    open={openMyAcc}
                    onClose={handleCloseMyAccDrop}
                  >
                    {/* 🔥 Change Password */}
                    <MenuItem onClick={openChangePassword}>
                      <ListItemIcon>
                        <LockReset fontSize="small" />
                      </ListItemIcon>
                      Change Password
                    </MenuItem>

                    {/* Logout */}
                    <MenuItem onClick={logout}>
                      <ListItemIcon>
                        <Logout fontSize="small" />
                      </ListItemIcon>
                      Logout
                    </MenuItem>
                  </Menu>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* ================= PASSWORD DIALOG ================= */}
      <Dialog
        open={openPasswordDialog}
        onClose={() => setOpenPasswordDialog(false)}
      >
        <DialogTitle>Change Password</DialogTitle>

        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
        >
          <TextField
            label="Current Password"
            type="password"
            name="currentPassword"
            value={passwordData.currentPassword}
            onChange={handlePasswordInput}
            fullWidth
          />

          <TextField
            label="New Password"
            type="password"
            name="newPassword"
            value={passwordData.newPassword}
            onChange={handlePasswordInput}
            fullWidth
          />

          <TextField
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            value={passwordData.confirmPassword}
            onChange={handlePasswordInput}
            fullWidth
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenPasswordDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={changePassword}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Header;
